
export enum ClickTarget {
    BID, ASK
}
